import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'

Vue.use(Vuex)

// 应用初始状态
const state = {
    user:{},
    rd: false,
    hisuser:{},
    partList:[],
    //basepath:'http://bms.ztwb.cn:7788',测试用这个
    basepath:'https://bms.ztwb.cn',
    good:{},
    itemmap:{
      202010:{},
      20201001:{}
    },
    schoollist: {},
    orderGood: {},
    addressList: [],
    editAddress: {
      Username: '',
      Addressid: '',
      Name: '',
      Phonenum: '',
      Address: '',
      AddressDetail: '',
      PostalCode: '',
      Isdefault: 0
    },
    addressId: '',
    insuranceOrderList:[],
    insuarance:{},
    HBgoods:[],
    Activity:{},
    eshopGood:{},
    nitemmap:{},
    orderDetails:{},
    CouponNum:'',
    healthItem:{},
    eshopUserInfo:{},
    currendIndex:[0],
    saveAnswer: [[]],
    errorExam:  [],
    examInfo: {},
    saveAnswerp: [],
    errorExamp:  [],
    allExamp:  [],
    examInfop: {},
    jobDetail:{},
    myToken:'',
    examType:0,
    surveyInfo: {},
    mediaTeamUserList: [],
    playid: {},
    currentPath:'',
    testResultText:[],
    jdCategoryId:0,
    jdOptions:[],
    djUser:{},
    shop:false
}


// 定义所需的 mutations
const mutations = {
  SETRD (state,u){
    state.rd = u
  },
  SETPLAYID (state,u){
    state.playid = u
  },
  SETUSER(state, u) {
    state.user = Object.assign({},u);
  },
  SETHISUSER(state, u) {
    state.hisuser = Object.assign({},u);
  },
  SETPARTLIST(state, u) {
    state.partList = u.slice(0)
  },
  SETGOOD(state, u) {
    state.good = Object.assign({},u);
  },
  SETORDERGOOD(state, u) {
    state.orderGood = Object.assign({},u);
  },
  SETADDRESSLIST(state, u) {
    state.addressList = u.slice(0);
  },
  SETADDRESSID(state, u) {
    state.addressId = u;
  },
  EDITADDRESS(state, u) {
    state.editAddress = Object.assign({},u);
  },
  SETINSURANCEORDERLIST(state, u) {
    state.insuranceOrderList = u.slice(0)
  },
  SETINSURANCE(state, u) {
    state.insuarance = Object.assign({},u);
  },
  SETHBGOODS(state, u) {
    state.HBgoods = u.slice(0)
  },
  SETITEMMAP(state, u) {
    state.itemmap = Object.assign({},state.itemmap,u);
  },
  SETACTIVITY(state, u) {
    state.Activity = Object.assign({},u);
  },
  SETESHOPGOOD(state, u) {
    state.eshopGood = Object.assign({},u);
  },
  SETNITEMMAP(state, u) {
    state.nitemmap = Object.assign({},u);
  },
  SETORDERDETAILS(state, u) {
    state.orderDetails =Object.assign({},u);
  },
  SETCOUPONNUM(state, u) {
    state.CouponNum = u;
  },
  SETHEALTHITEM(state, u) {
    state.healthItem =Object.assign({},u);
  },
  // SETESHOPUSERINFO(state, u) {
  //   state.eshopUserInfo =Object.assign({},u);
  // },
  NEXTITEM(state,u) {
    console.log('PREITEMu',u)
    const sp = [...state.currendIndex]
    sp[u] += 1
    state.currendIndex = sp
  },
  PREITEM(state,u) {
    console.log('PREITEMu',u)
    const sp = [...state.currendIndex]
    sp[u] -= 1
    state.currendIndex = sp
  },
  SETERROREXAM(state, u) {
    state.errorExam = u.slice(0)
  },
  SETEXAMINFO(state, u) {
    state.examInfo = Object.assign({},u);
  },
  RESETCURRENDINDEX(state) {
    state.currendIndex = [ ]
  },
  SETCURRENDINDEX(state,u) {
    state.currendIndex = u.slice(0)
  },
  SETSAVEANSWER(state,u) {
    state.saveAnswer = u.slice(0)
  },
  RESETSAVEANSWER(state,u) {
    state.saveAnswer = []
  },
  SETERROREXAMP(state, u) {
    state.errorExamp = u.slice(0)
  },
  SETALLEXAMP(state, u) {
    state.allExamp = u.slice(0)
  },
  SETEXAMINFOP(state, u) {
    state.examInfop = Object.assign({},u);
  },
  SETSAVEANSWERP(state,u) {
    state.saveAnswerp = u.slice(0)
  },
  RESETSAVEANSWERP(state,u) {
    state.saveAnswerp = []
  },
  SETJOBDETAIL(state, u) {
    state.jobDetail = Object.assign({},u);
  },
  SETMYTOKEN(state, u) {
    state.myToken = u
  },
  SETEXAMTYPE(state, u) {
    state.examType = u
  },
  SETSURVEYINFO(state, u) {
    state.surveyInfo = u
  },
  SETSCHOOLLIST(state, l) {
    state.schoollist = l
  },
  SETMEDIATEAMUSERLIST(state,u) {
    state.mediaTeamUserList = u.slice(0)
  },
  SETCURRENTPATH(state,u) {
    state.currentPath = u
  },
  SETTESTRESULTTEXT(state,u) {
    state.testResultText = u.slice(0)
  },
  SETJDCATEGORYID(state,u) {
    state.jdCategoryId = u
  },
  SETJDOPTIONS(state,u) {
    state.jdOptions = u.slice(0)
  },
  SETDJUSER(state, u) {
    state.djUser = Object.assign({},u);
  },
  SETSHOP (state,u){
    state.shop = u
  },
}




// 创建 store 实例
export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations
})

